import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { SMALL_HEADER_HEIGHT } from 'styleguide';
import PropTypes from 'prop-types';

import Snoozes from 'api/resources/snoozes';
import getErrors from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import { ReactComponent as SnoozesIcon } from 'icons/Snoozes.svg';

import Loader from 'components/Loader';
import SnoozesActiveItem from 'admin-editor/containers/SnoozesActiveItem';

import ErrorText from 'styled/Page/ErrorText';
import CenteredContainer from 'styled/Page/CenteredContainer';
import HeaderTitle from 'styled/Page/HeaderTitle';
import Header from 'styled/Page/Header';
import SimpleList from 'styled/SimpleList';

export class ActiveSnoozes extends React.PureComponent {
  state = {
    loading: false,
    snoozes: [],
    errors: [],
  }

  componentDidMount() {
    this.loadSnoozes();
  }

  componentDidUpdate(prevProps) {
    if (this.props.reloadOnActivateSnooze !== prevProps.reloadOnActivateSnooze) {
      this.loadSnoozes();
    }
  }

  handleDeactivate = (snooze) => {
    this.setState(prevState => ({
      snoozes: prevState.snoozes.filter(item => item.id !== snooze.id),
    }));
    this.props.onDeactivate(snooze);
  }

  loadSnoozes = async () => {
    this.setState({
      loading: true,
      errors: [],
      snoozes: [],
    });

    try {
      const response = await Snoozes.getAll({
        page: { size: 24 },
        filter: { is_active: true },
        fields: { snooze: 'name' },
      });

      const snoozes = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState({
        snoozes,
        loading: false,
      });
    } catch (err) {
      getErrors(err).then((errors) => {
        this.setState({
          errors,
          loading: false,
        });
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <Header>
          <HeaderTitle>
            активные снузы ({this.state.snoozes.length} из 24)
          </HeaderTitle>
        </Header>

        <Scrollbars
          autoHide
          autoHeight
          autoHeightMax={`calc(100vh - ${SMALL_HEADER_HEIGHT})`}
        >
          {!this.state.loading &&
            this.state.snoozes.length !== 0 &&
            this.state.errors.length === 0 && (
            <SimpleList style={{ padding: '9px 32px 7px 24px' }}>
              {this.state.snoozes.map(item => (
                <SnoozesActiveItem
                  key={item.id}
                  id={item.id}
                  name={item.name}
                  onDeactivate={this.handleDeactivate}
                />
              ))}
            </SimpleList>
          )}

          {this.state.errors.length > 0 && (
            <CenteredContainer>
              {this.state.errors.map(error => (
                <ErrorText role="alert" key={error}>{error}</ErrorText>
              ))}
            </CenteredContainer>
          )}

          {!this.state.loading &&
            this.state.snoozes.length === 0 &&
            this.state.errors.length === 0 && (
            <CenteredContainer>
              <SnoozesIcon />

              <ErrorText>Активных снузов нет</ErrorText>
            </CenteredContainer>
          )}

          {this.state.loading && <CenteredContainer><Loader /></CenteredContainer>}
        </Scrollbars>
      </React.Fragment>
    );
  }
}

ActiveSnoozes.propTypes = {
  reloadOnActivateSnooze: PropTypes.bool,
  onDeactivate: PropTypes.func,
};

ActiveSnoozes.defaultProps = {
  reloadOnActivateSnooze: false,
  onDeactivate: () => {},
};

export default ActiveSnoozes;
